'use client';
import ReconciliationDashboard from './components/ReconciliationDashboard';

export default function ReconciliationPage() {
  return <ReconciliationDashboard />;
}
